import React from "react";
import { Box, Divider, Grid, Tabs, TabList, TabPanels, Tab, TabPanel, IconButton } from '@chakra-ui/react'
import TableMzl from "./TableMzl";
import TableUch from "./TableUch";
import TableBoss from "./TableBoss";
import TableCLN from "./TableCLN";
import {useNavigate} from "react-router-dom";
import { BiExit } from "react-icons/bi";

const Tabss = () => {
  const navigate = useNavigate();

  const signOut = () => {
    localStorage.removeItem('me3To_keN9rud')
    navigate("/");
  }

  return (
    <Tabs variant='soft-rounded' align='center'>
      <Grid templateColumns='repeat(3, 1fr)'>
        <Box />
        <TabList>
          <Tab _selected={{ color: 'white', bg: 'gray.700' }} ml='15px'>Реализация</Tab>
          <Tab _selected={{ color: 'white', bg: 'gray.500' }} ml='15px'>Учет</Tab>
          <Tab _selected={{ color: 'white', bg: 'gray.300' }} ml='15px'>МЗЛ</Tab>
          <Tab _selected={{ color: 'white', bg: 'gray.300' }} ml='15px'>ПРИМЕР</Tab>
        </TabList>
        <Box display='flex' alignItems='right' justifyContent='right' mr={1} mt={1}>
          <IconButton icon={<BiExit />} onClick={signOut} />
        </Box>
      </Grid>
      <TabPanels overflowX='scroll'>
        <TabPanel>
          <TableBoss />
        </TabPanel>
        <TabPanel>
          <TableUch />
        </TabPanel>
        <TabPanel>
          <TableMzl />
        </TabPanel>
        <TabPanel>
          <TableCLN />
        </TabPanel>
      </TabPanels>
      <Box bg='gray.200' w='100%' p={10} color='white'>
        <Divider />
      </Box>
    </Tabs>
    );
};

export default Tabss;